<script>
import options from './NewLoanCalculatorResultMobile.options'
export default options
</script>

<template>
    <section class="nyk-new-loan-calculator-result-mobile">
        <button v-if="summaries.length > 1" v-on:click="quitCompareMode" class="nyk-new-loan-calculator-result__back-button">
            <div class="nyk-new-loan-calculator-result__back-button-icon">
                <div class="nyk-button__icon">
                    <svg role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 13">
                        <path fill="var(--colortheme-icon)" d="M16 7.218V5.762H3.005L7.461.748 6.694 0 0 6.51 6.694 13l.767-.748-4.456-5.034H16Z" />
                    </svg>
                </div>
            </div>
            <span class="nyk-new-loan-calculator-result__back-button-label">{{ labels.backButtonLabel }}</span>
        </button>

        <h1 class="nyk-new-loan-calculator-result__title" aria-live="polite" v-if="labels.resultTitle && labels.compareTitle">
            {{ summaries.length > 1 ? labels.compareTitle : labels.resultTitle }}
        </h1>

        <div
            class="nyk-new-loan-calculator-result__info-container"
            :class="{ 'nyk-new-loan-calculator-result__info-container--multiple': summaries.length > 1 }">
            <template v-if="summaries.length === 1" v-for="(summary, singleSummaryIndex) in summaries" :key="singleSummaryIndex">
                <CalculatorSummary
                    v-if="summary"
                    :data="summary"
                    :labels="labels"
                    :hasHousingTypes="getLoanTypesForSummary(singleSummaryIndex).length > 1"
                    :onCallback="() => switchLoanTypeWithRedirect(singleSummaryIndex)" />


                    <section class="nyk-new-loan-calculator-result__info-container-actions">
                        <template v-for="(link, i) in links" :key="i">
                            <a v-if="link.link?.url || link.anchorId"
                                class="nyk-button"
                                :class="link.type === 'primary' ? 'nyk-button--filled-primary-dark' : 'nyk-button--outline-primary'"
                                :aria-label="link.ariaLabel"
                                :href="link.link?.url || ('#' + link.anchorId)"
                                :target="link.link?.target"
                                :rel="link.link?.target ? 'noopener' : null">
                                {{ link.label }}
                            </a>
                        </template>

                        <button class="nyk-button nyk-button--outline-primary" v-on:click="openCompareLoanModal">
                            {{ labels.compareLoanButtonLabel }}
                        </button>
                        <button
                            class="nyk-button nyk-button--outline-primary"
                            aria-haspopup="true"
                            v-on:click="() => adjustLoanWithRedirect(singleSummaryIndex)">
                            {{ labels.adjustLoanButtonLabel }}
                        </button>
                    </section>
                <!-- <div class="nyk-new-loan-calculator-result__info-container-actions">
                        {{ labels.sendCalculationButtonLabel }}
                    </a>
                    <button class="nyk-button nyk-button--outline-primary" v-on:click="openCompareLoanModal">
                        {{ labels.compareLoanButtonLabel }}
                    </button>
                    <button
                        class="nyk-button nyk-button--outline-primary"
                        aria-haspopup="true"
                        v-on:click="() => adjustLoanWithRedirect(singleSummaryIndex)">
                        {{ labels.adjustLoanButtonLabel }}
                    </button>
                </div> -->

                <CalculatorInfoBox v-if="infoBox[singleSummaryIndex]" :data="infoBox[singleSummaryIndex]" />
            </template>

            <template v-else v-for="(summary, multipleSummariesIndex) in summaries" :key="multipleSummariesIndex">
                <div class="nyk-new-loan-calculator-result__info-container-wrapper">
                    <CalculatorSummary
                        v-if="summary"
                        :data="summary"
                        :labels="labels"
                        :onCallback="() => switchLoanType(multipleSummariesIndex)"
                        :hasHousingTypes="getLoanTypesForSummary(multipleSummariesIndex).length > 1"
                        :hasGraph="false" />

                    <button
                        class="nyk-button nyk-button--outline-primary"
                        aria-haspopup="true"
                        v-on:click="() => adjustLoan(multipleSummariesIndex)">
                        {{ labels.adjustLoanButtonLabel }}
                    </button>
                </div>
            </template>
        </div>

        <SendCalculation
            v-if="sendCalculation && sendCalculation.showSendCalculation && summaries.length === 1"
            :labels="sendCalculation.labels"
            :formId="sendCalculation.formId"
            :formTypeName="sendCalculation.formTypeName"
            :salesforceidApiUrl="sendCalculation.salesforceidApiUrl"
            :sendCalculationApiUrl="sendCalculation.sendCalculationApiUrl"
            :calculatorType="sendCalculation.calculatorType"
            :backgroundColor="sendCalculation.backgroundColor"
            :redirectLink="sendCalculation.redirectLink"
            :onResetCallback="() => {}" />

        <div class="nyk-new-loan-calculator-result__table-sections">
            <template v-if="tables.length === 1" v-for="(table, tableIndex) in tables" :key="tableIndex">
                <section class="nyk-new-loan-calculator-result__table-sections__content" :id="`table_${tableIndex}`">
                    <template v-for="(group, groupIndex) in table" :key="groupIndex">
                        <h2 class="nyk-new-loan-calculator-result__table-sections__content-title">{{ group.title }}</h2>

                        <template v-for="(table, tableIndex) in group.tables" :key="tableIndex">
                            <CalculatorTable
                                :headers="getTableHeaders(table)"
                                :tooltip="table.tooltip"
                                :collapse="table.value ? true : false"
                                :rows="getTableRows(table)"
                                :labels="labels" />
                        </template>
                    </template>
                </section>
            </template>
            
            <CalculatorCompareTable 
                v-if="tables.length > 1" 
                :tables="tables" 
                :labels="labels" 
            />
        </div>
    </section>
</template>
